export const apiPrefix = '/api/ft/v1'
export const typingDelay = 250
export const manualLink = 'https://help.fit.cvut.cz/projects-fit/'
export const stateExamsLink = 'https://courses.fit.cvut.cz/SZZ/'
export const issuesLink = 'https://servicedesk.cvut.cz/Alvao/Portal?serviceId=1152'
export const personRegistrationLink = 'https://servicedesk.cvut.cz/Alvao/Portal?serviceId=1132'
